import { useSyncExternalStore } from 'use-sync-external-store/shim/index.js';
import { getSnapshot, subscribe } from './react-store-helper.js';

export default function useStore() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
